module.exports = __webpack_public_path__ + "img/menu-bars.6e922253.svg";